/**
 * Extracts the service code from a backendServiceId.
 *
 * The backendServiceId format is typically: "OE-12345-S1000000"
 * where "S1000000" is the service code (the part after the last dash).
 *
 * @param backendServiceId - The backend service ID (e.g., "OE-12345-S1000000")
 * @returns The service code (e.g., "S1000000"), or the original value if no dash is found
 *
 * @example
 * extractServiceCode("OE-12345-S1000000") // returns "S1000000"
 * extractServiceCode("COMPANY-ACCOUNT-X123456") // returns "X123456"
 * extractServiceCode("S1000000") // returns "S1000000"
 */
export const extractServiceCode = (backendServiceId: string): string => {
  if (!backendServiceId || typeof backendServiceId !== "string") return "";

  const idx = backendServiceId.lastIndexOf("-");
  const code =
    idx >= 0 ? backendServiceId.slice(idx + 1).trim() : backendServiceId;

  // Return the service code if valid (non-empty after trimming), otherwise return the original value
  return code || backendServiceId;
};
